import $ from 'jquery'
import { ENVIRONMENT } from '@/commons/configuration'

export class AuthenticationUtils {
    private static timeoutId: number
    private static timeoutWarningId: number

    static refreshSession (): void {
        clearTimeout(this.timeoutWarningId)
        clearTimeout(this.timeoutId)
        this.timeoutWarningId = setTimeout(() => {
            $('#timeoutWarningModal').modal('show')
        }, (ENVIRONMENT.sessionTimeout.logOutInSeconds - ENVIRONMENT.sessionTimeout.warningBufferInSeconds) * 1000)
        this.timeoutId = setTimeout(() => {
            document.location.reload()
        }, ENVIRONMENT.sessionTimeout.logOutInSeconds * 1000)
    }

    static clearSessionModalsAndTimeouts (): void {
        $('.modal').modal('hide')
        clearTimeout(this.timeoutWarningId)
        clearTimeout(this.timeoutId)
    }
}
